var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRtoForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2962_5596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33C28.0751 33 33 28.0751 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 28.0751 15.9249 33 22 33Z",
    fill: "#667080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.581 25V19.5041H17.3554C17.7846 19.5041 18.1353 19.5748 18.4074 19.7161C18.6796 19.8574 18.8811 20.0511 19.012 20.2971C19.1428 20.5431 19.2083 20.8153 19.2083 21.1136C19.2083 21.4591 19.114 21.7705 18.9256 22.0479C18.7424 22.3253 18.4545 22.5216 18.062 22.6368L19.2632 25H18.486L17.3711 22.731H17.324H16.2405V25H15.581ZM16.2405 22.2128H17.3083C17.7322 22.2128 18.041 22.1107 18.2347 21.9066C18.4284 21.7025 18.5252 21.4408 18.5252 21.1215C18.5252 20.797 18.4284 20.5405 18.2347 20.3521C18.0463 20.1584 17.7348 20.0616 17.3004 20.0616H16.2405V22.2128ZM21.5226 25V20.0459H19.8817V19.5041H23.823V20.0459H22.1821V25H21.5226ZM26.8413 25.0942C26.3022 25.0942 25.8285 24.9764 25.4203 24.7409C25.0172 24.5001 24.7006 24.1652 24.4703 23.736C24.2452 23.3067 24.1326 22.8121 24.1326 22.2521C24.1326 21.692 24.2452 21.2 24.4703 20.776C24.7006 20.3468 25.0172 20.0118 25.4203 19.7711C25.8285 19.5303 26.3022 19.4099 26.8413 19.4099C27.3857 19.4099 27.8594 19.5303 28.2624 19.7711C28.6707 20.0118 28.9873 20.3468 29.2124 20.776C29.4375 21.2 29.55 21.692 29.55 22.2521C29.55 22.8121 29.4375 23.3067 29.2124 23.736C28.9873 24.1652 28.6707 24.5001 28.2624 24.7409C27.8594 24.9764 27.3857 25.0942 26.8413 25.0942ZM26.8413 24.5132C27.2444 24.5132 27.5977 24.4242 27.9012 24.2463C28.2101 24.0631 28.4482 23.804 28.6157 23.469C28.7884 23.1288 28.8748 22.7231 28.8748 22.2521C28.8748 21.781 28.7884 21.378 28.6157 21.043C28.4482 20.708 28.2101 20.4515 27.9012 20.2736C27.5977 20.0904 27.2444 19.9988 26.8413 19.9988C26.4383 19.9988 26.0824 20.0904 25.7736 20.2736C25.47 20.4515 25.2318 20.708 25.0591 21.043C24.8916 21.378 24.8079 21.781 24.8079 22.2521C24.8079 22.7231 24.8916 23.1288 25.0591 23.469C25.2318 23.804 25.47 24.0631 25.7736 24.2463C26.0824 24.4242 26.4383 24.5132 26.8413 24.5132Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2962_5596",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.6 0 0 0 0 0.705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2962_5596"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2962_5596",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtoForm);
export default __webpack_public_path__ + "static/media/rto-form.df969442ae65d8fb2d82da020c2c5f7d.svg";
export { ForwardRef as ReactComponent };